import { Component, OnInit } from '@angular/core';

import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-logoff',
  templateUrl: './logoff.component.html',
  styleUrls: ['./logoff.component.scss']
})
export class LogoffComponent implements OnInit {

  constructor(private oauthService: OAuthService) { }

  ngOnInit(): void {

    this.logout ();

  }

  logout () {

    this.oauthService.logOut();
    this.oauthService.silentRefresh();
  }

}
